import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import styled from 'styled-components';
import { ErrorOutlineOutlined as ErrorIcon } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

import { TableSelect } from '../../../screens/ChargersList/components/ChargersTableComponents';
import {
  CHARGER_TASK_STATUS_LABEL_VALUE_LIST,
  CHARGER_TASK_STATUS_VALUE_LABEL_MAP,
  CHARGER_TASK_TYPE_VALUE_LABEL_MAP,
  ERROR_CHARGER_TASK_STATUS,
} from '../../constants/chargerTask';
import { iotOnDateFormat } from '../../services/ValidationRules';
import { onDatePickerFilter } from '../CommonTableDataFilter/CommonTableDataFilter';
import { makeMenuItems } from '../Helper/helper';
import { getCurrentChargerCustomerId } from '../../../screens/ChargerDetails/selectors';
import { getCustomerId } from '../../../screens/Login/selectors';

import SSPList from '../SSPList';
import DetailsTrigger from './detailsTrigger';
import { makeTaskActions } from './helper';
import { NotAvailable } from './styles';
import { StatusLabel } from '../../constants/CommonUsedDropdownsStatics';

export const taskSSPId = 'tasks';
export const POLLING_INTERVAL = 3000;

function ChargerTasksSSPList({ userPermissions, charger, onGetDataAction, labels, isDiagnosticsAvailable, checkInteractionDiscovery }) {
  const currentChargerCustomerId = useSelector(getCurrentChargerCustomerId);
  const customerId = useSelector(getCustomerId);
  const filterSupervisorRole = (columns) =>
    currentChargerCustomerId === customerId ? columns : columns.filter(({ id }) => id !== 'action');

  useEffect(() => {
    checkInteractionDiscovery();
  }, []);

  const columns = [
    {
      Header: 'Request Date/Time (UTC)',
      id: 'requestedAt',
      accessor: 'requestedAt',
      maxWidth: 250,
      Cell: ({ value }) =>
        moment
          .unix(value / 1000)
          .utc()
          .format(iotOnDateFormat),
      Filter: onDatePickerFilter,
    },
    {
      Header: 'Task Type',
      id: 'type',
      accessor: 'type',
      maxWidth: 250,
      Cell: ({ value, original }) => <DetailsTrigger task={original}>{CHARGER_TASK_TYPE_VALUE_LABEL_MAP[value]}</DetailsTrigger>,
      filterable: false,
      // TODO: Activate this filter when got more task types
      // Filter: ({ filter, onChange }) => (
      //   <TableSelect
      //     options={makeMenuItems(CHARGER_TASK_TYPE_LABEL_VALUE_LIST, { emptyItem: true })}
      //     onChange={onChange}
      //     value={filter ? filter.value : ''}
      //   />
      // )
    },
    {
      Header: 'Notes',
      id: 'note',
      accessor: 'note',
      minWidth: 130,
    },
    {
      Header: 'Requested By',
      id: 'initiator',
      accessor: 'initiator',
      maxWidth: 250,
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: 'status',
      maxWidth: 250,
      Cell: (props) => {
        const {
          original: { statusDetails },
          value,
        } = props;

        if (value === ERROR_CHARGER_TASK_STATUS) {
          return (
            <Tooltip title={statusDetails} placement="top">
              <StatusLabel status={value} />
            </Tooltip>
          );
        }

        return <StatusLabel status={value} />;
      },
      Filter: ({ filter, onChange }) => (
        <TableSelect
          options={makeMenuItems(CHARGER_TASK_STATUS_LABEL_VALUE_LIST, {
            emptyItem: '',
            emptyItemLabel: 'All',
            labels,
            labelKey: 'chargerTaskStatus',
          })}
          onChange={onChange}
          value={filter ? filter.value : ''}
        />
      ),
    },
    {
      Header: 'Action',
      id: 'action',
      minWidth: 130,
      filterable: false,
      sortable: false,
      Cell: ({ original }) => makeTaskActions({ ...original, chargerUuid: charger.c_uuid }, userPermissions),
    },
  ];

  if (!isDiagnosticsAvailable) {
    return <NotAvailable>Get Diagnostics functionality is not available for this device.</NotAvailable>;
  }

  return (
    <SSPList
      mobileSticky
      onGetDataAction={onGetDataAction}
      defaultSorted={{ id: 'requestedAt', desc: true }}
      defaultPageSize={20}
      id={taskSSPId}
      clearFilterOnInit
      columns={filterSupervisorRole(columns)}
      polling={{ interval: POLLING_INTERVAL }}
    />
  );
}

export const ErrorWrap = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  .MuiSvgIcon-root {
    margin-right: 5px;
    font-size: 16px;
    color: #e65819;
  }
`;

export default ChargerTasksSSPList;
